
export class Categoria {
    public icon = 'fa fa-desktop prefix text-primary';
    public title = 'Categoría';
    public list = [];
}




// WEBPACK FOOTER //
// ./src/app/shared/domain/categorias.ts